import { render, staticRenderFns } from "./TheFailedSendsPanel.vue?vue&type=template&id=646a5f38&scoped=true"
import script from "./TheFailedSendsPanel.vue?vue&type=script&lang=js"
export * from "./TheFailedSendsPanel.vue?vue&type=script&lang=js"
import style0 from "./TheFailedSendsPanel.vue?vue&type=style&index=0&id=646a5f38&prod&lang=scss"
import style1 from "./TheFailedSendsPanel.vue?vue&type=style&index=1&id=646a5f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646a5f38",
  null
  
)

export default component.exports